/** The frames are drawn at 1920x1080, and every size in them is a rendered pixel at that height. */
const FRAME_HEIGHT = 1080;
const FRAME_WIDTH = 1920;

/**
 * One of the frames' pixel sizes, as a share of the screen's height.
 *
 * The score column has to fit eight singers in the space between the lyrics, and that space is a
 * share of the screen: a card of fixed pixels that fits at 1080 overflows a 720px-tall window.
 * Sized this way it renders at exactly the frames' pixels at 1080 and shrinks with the screen below.
 * It also follows the width, so on a screen narrower than 16:9 it still fits the space set aside for it.
 */
export const ofFrame = (px: number) =>
  `min(${((px / FRAME_HEIGHT) * 100).toFixed(3)}vh, ${((px / FRAME_WIDTH) * 100).toFixed(3)}vw)`;
